import React from 'react'
import { MenuItem, Menu, MenuList, Divider } from '@mui/material'
import { ColoursObj } from '@eventr/common-storybook'

export interface Action {
    child: React.ReactNode

    callback: () => void
    disabled?: boolean
}

export interface ActionPopoverProps {
    actions: Action[]
    anchorEl: HTMLElement | null
    open: boolean
    onClose: () => void
}

export const ActionPopover: React.FC<ActionPopoverProps> = ({
    actions,
    anchorEl,
    open,
    onClose,
}) => {
    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
        >
            <MenuList
                dense
                style={{
                    width: '180px',
                    border: '1px solid #E0E0E0',
                    borderRadius: '8px',
                    background: ColoursObj.backgrounds.primary,
                }}
            >
                {actions.map((action, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            action.callback()
                            onClose()
                        }}
                        disabled={action.disabled}
                    >
                        {action.child}
                        {actions.length - 1 !== index && (
                            <Divider
                                key={'divider' + index}
                                style={{ margin: '0px' }}
                            />
                        )}
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    )
}
